<template>
    <section id="login">
        <div class="content-register container">
            <div class="content-register-logos">
                <img v-for="logo in logos" :key="logo.id" :src="logo.path" alt="logo cafe da sorte">
            </div>
            <div class="content-register-text">
                <p>{{ text }}</p>
            </div>
            <div v-if="userIsLogged" class="account-btn">
                <router-link tag="button" to="/account">Aceder à sua conta</router-link>
            </div>
            <div class="content-register-form" v-else>
                <form @submit.prevent="sendPass()">
                    <div class="row">
                        <div class="col-lg-6">
                            <input
                                type="text"
                                name="mobile"
                                v-model="mobile"
                                placeholder="Nº telemóvel"
                                maxlength="9"
                                @keypress="onlyNumbers"
                            />
                        </div>
                        <div class="col-lg-6">
                            <input
                                type="password"
                                name="password"
                                v-model="password"
                                placeholder="Password"
                            />
                        </div>
                    </div>  
                    <div class="btn">
                        <button type="submit">seguinte</button>
                    </div>
                    <!-- <div class="content-or">
                        <p>ou entrar com</p>
                        <div class="content-or-social">
                            <div @click="loginWithApple()">
                                <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="78" height="78" viewBox="0 0 78 78">
                                    <defs>
                                        <filter id="Rectangle_2259" x="0" y="0" width="78" height="78" filterUnits="userSpaceOnUse">
                                        <feOffset dx="3" dy="3" input="SourceAlpha"/>
                                        <feGaussianBlur stdDeviation="3" result="blur"/>
                                        <feFlood flood-opacity="0.349"/>
                                        <feComposite operator="in" in2="blur"/>
                                        <feComposite in="SourceGraphic"/>
                                        </filter>
                                        <clipPath id="clip-path">
                                        <rect id="Rectangle_2261" data-name="Rectangle 2261" width="60" height="60" fill="none"/>
                                        </clipPath>
                                    </defs>
                                    <g id="Group_4179" data-name="Group 4179" transform="translate(-54 -490)">
                                        <g id="Group_4178" data-name="Group 4178" transform="translate(-70)">
                                        <g transform="matrix(1, 0, 0, 1, 124, 490)" filter="url(#Rectangle_2259)">
                                            <rect id="Rectangle_2259-2" data-name="Rectangle 2259" width="60" height="60" rx="10" transform="translate(6 6)"/>
                                        </g>
                                        </g>
                                        <g id="Group_4184" data-name="Group 4184" transform="translate(60 496)">
                                        <g id="Group_4183" data-name="Group 4183">
                                            <g id="Group_4182" data-name="Group 4182" clip-path="url(#clip-path)">
                                            <path id="Path_5555" data-name="Path 5555" d="M25.031,15.98a4.886,4.886,0,0,0,3.4-1.845A6,6,0,0,0,29.76,10.51a2.466,2.466,0,0,0-.048-.51,5.535,5.535,0,0,0-3.691,1.976,5.686,5.686,0,0,0-1.375,3.509,2.267,2.267,0,0,0,.049.461,1.663,1.663,0,0,0,.335.034m-4,19.93c1.55,0,2.238-1.07,4.171-1.07,1.965,0,2.4,1.038,4.122,1.038,1.694,0,2.828-1.615,3.9-3.195a14.729,14.729,0,0,0,1.726-3.674A5.672,5.672,0,0,1,31.6,23.77a5.9,5.9,0,0,1,2.7-4.942,5.844,5.844,0,0,0-4.97-2.569c-1.9,0-3.451,1.186-4.426,1.186-1.054,0-2.445-1.121-4.091-1.121-3.132,0-6.312,2.669-6.312,7.709a16.266,16.266,0,0,0,2.637,8.581c1.246,1.812,2.333,3.295,3.9,3.295" transform="translate(5.273 3.636)" fill="#fff"/>
                                            </g>
                                        </g>
                                        </g>
                                    </g>
                                </svg>
                            </div>
                            <div @click="loginWithGoogle()">
                                <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="78" height="78" viewBox="0 0 78 78">
                                    <defs>
                                        <filter id="Rectangle_2259" x="0" y="0" width="78" height="78" filterUnits="userSpaceOnUse">
                                        <feOffset dx="3" dy="3" input="SourceAlpha"/>
                                        <feGaussianBlur stdDeviation="3" result="blur"/>
                                        <feFlood flood-opacity="0.349"/>
                                        <feComposite operator="in" in2="blur"/>
                                        <feComposite in="SourceGraphic"/>
                                        </filter>
                                    </defs>
                                    <g transform="matrix(1, 0, 0, 1, 0, 0)" filter="url(#Rectangle_2259)">
                                        <rect id="Rectangle_2259-2" data-name="Rectangle 2259" width="60" height="60" rx="10" transform="translate(6 6)" fill="#fff"/>
                                    </g>
                                    <g id="Google__G__Logo" transform="translate(21.993 21.706)">
                                        <path id="Path_4770" data-name="Path 4770" d="M-1089.33-687.239v5.536h7.693a6.591,6.591,0,0,1-2.872,4.3l4.639,3.6a13.965,13.965,0,0,0,4.262-10.512,16.421,16.421,0,0,0-.26-2.924Z" transform="translate(1103.623 698.934)" fill="#4285f4"/>
                                        <path id="Path_4771" data-name="Path 4771" d="M-1169.611-651.791l-1.046.8-3.7,2.885h0a14.291,14.291,0,0,0,12.76,7.887,13.642,13.642,0,0,0,9.46-3.456l-4.639-3.6a8.515,8.515,0,0,1-4.821,1.377,8.534,8.534,0,0,1-8-5.886Z" transform="translate(1175.894 668.805)" fill="#34a853"/>
                                        <path id="Path_4772" data-name="Path 4772" d="M-1183.044-712.61a14.116,14.116,0,0,0-1.533,6.406,14.116,14.116,0,0,0,1.533,6.406c0,.013,4.756-3.69,4.756-3.69a8.567,8.567,0,0,1-.455-2.716,8.568,8.568,0,0,1,.455-2.716Z" transform="translate(1184.577 720.498)" fill="#fbbc05"/>
                                        <path id="Path_4773" data-name="Path 4773" d="M-1161.6-759.479a7.8,7.8,0,0,1,5.471,2.131l4.093-4.093a13.713,13.713,0,0,0-9.564-3.729,14.268,14.268,0,0,0-12.76,7.888l4.756,3.69A8.533,8.533,0,0,1-1161.6-759.479Z" transform="translate(1175.895 765.171)" fill="#ea4335"/>
                                    </g>
                                </svg>      
                            </div>
                        </div>
                    </div> -->
                </form>
                <div class="recover-password">
                    <a @click="$bvModal.show('modal-recpassword')">Recuperar palavra-passe</a>
                </div>
                <div class="create-account">
                    <router-link tag="button" to="/create-account">Criar conta</router-link>
                </div>
            </div>
        </div>
        <RecoverPassword />
        <ConfirmReset />
        <ChangePassword />
    </section>
</template>
<script>
import axios from 'axios';
import RecoverPassword from '../../../components/modals/RecoverPassword.vue';
import ConfirmReset from '../../../components/modals/ConfirmReset.vue';
import ChangePassword from '../../../components/modals/ChangePassword.vue';
import { mapGetters, mapActions } from 'vuex';

  export default {
    name: 'Register',
    components: {
        RecoverPassword,
        ConfirmReset,
        ChangePassword
    },
    data() {
        return {
            mobile: '',
            password: '',
        }
    },
    computed: {
        ...mapGetters(['userIsLogged'])
    },
    props: {
        text: {
            type: String,
            default: ''
        },
        logos: {
            type: Array,
            default: () => {}
        },
    },
    methods: {
        ...mapActions(["accountLogin"]),
        onlyNumbers(event) {
            const charCode = event.which ? event.which : event.keyCode;
            if (charCode > 31 && (charCode < 48 || charCode > 57)) {
                event.preventDefault();
            }
        },
        async sendPass(){
            let user = {
                mobile: this.mobile,
                password: this.password
            };
            if (this.mobile.charAt(0) !== '9') {
                this.$swal.fire({
                    type: 'error',
                    title: 'Erro',
                    text: 'O número de telemóvel deve começar com 9.',
                    timer: 3000,
                });
                return;
            }
            await this.$store.dispatch("accountLogin", user)
            .then((response) => {
              if (response.data.success) {
                this.$swal.fire({
                  icon: 'success',
                  type: 'success',
                  title: 'Sucesso',
                  text: 'Login efetuado com sucesso',
                  showConfirmButton: false,
                  timer: 3000,
                });
                  this.$router.push({ name: 'Account' });
              } else {
                this.$swal.fire({
                  icon: 'error',
                  type: 'error',
                  title: 'Erro',
                  text: 'Dados inválidos, se já tem conta criada, faça recuperação da palavra-passe',
                  showConfirmButton: false,
                  timer: 3000,
                });
              }
            })
            .catch((error) => {
              console.log(error);
              this.$swal.fire({
                icon: 'error',
                type: 'error',
                title: 'Erro',
                text: 'Dados inválidos, se já tem conta criada, faça recuperação da palavra-passe',
                showConfirmButton: false,
                timer: 3000,
              });
            });
        },
        loginWithApple(){
            axios.get('/auth/apple/redirect')
            .then((response) => {
                console.log(response);
            }, (error) => {
                console.log(error);
            });
        },
        loginWithGoogle(){
            axios.get('/auth/google/redirect')
            .then((response) => {
                window.location.href = response.data.data;
            }, (error) => {
                console.log(error);
            });
        },
    },
  }
</script>
<style lang="scss">
#login{
    padding-top: 120px;
}
.content-register{
    margin: 40px auto 160px auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    @media screen and (max-width: 992px){
        padding-left: 25px;
        padding-right: 25px;
    }
    &-logos{
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        max-width: 1088px;
        gap: 10px;
        margin-bottom: 35px;
        img{
            width: 135px;
            height: auto;
        }
    }
    &-text{
        max-width: 1088px;
    }
    &-form{
        width: 100%;
        max-width: 1088px;
        form{
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            .row{
                width: 100%;
                display: flex;
                justify-content: space-between;
                margin: 40px 0;
                @media screen and (max-width: 992px){
                    gap: 30px;
                }
                input{
                    width: 100%;
                    max-width: 500px;
                    height: 60px;
                    border-radius: 10px;
                    border: 1px solid black;
                    padding: 0 20px;
                    font-size: 18px;
                    line-height: 24px;
                    color: black;
                    text-align: center;
                    &::placeholder{
                        color: black;
                        text-align: center;
                        font-size: 18px;
                        line-height: 24px;
                    }
                }
            }
            .btn{
                width: 100%;
                max-width: 500px;
                button{
                    width: 100%;
                    height: 60px;
                    border-radius: 10px;
                    border: none;
                    background: rgb(254,206,9);
                    background: linear-gradient(90deg, rgba(254,206,9,1) 0%, rgba(245,137,31,1) 100%);
                    color: #000;
                    font-size: 18px;
                    font-weight: bold;
                    cursor: pointer;
                    text-transform: uppercase;
                }
            }
            p{
                margin-top: 40px;
                margin-bottom: 20px;
                font-size: 18px;
                color: #707070;
            }
            .content-or{
                display: flex;
                justify-content: space-between;
                align-items: center;
                flex-direction: column;
                &-social{
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    svg{
                        width: 60px;
                        height: 60px;
                        cursor: pointer;
                    }
                }
            }
        }
        .recover-password{
            padding: 10px 0 38px 0;
            border-bottom: 1px solid #B8B8B8;
            a{
                all:unset;
                font-family: 'Font Bold';
                font-size: 14px;
                line-height: 20px;
                color: #000;
                text-decoration: underline!important;
            }
        }
        .create-account{
            padding: 50px 0 0 0;
            button{
                all:unset;
                width: 320px;
                max-width: 100%;
                height: 56px;
                border-radius: 10px;
                border: 1px solid #B00F0C;
                box-shadow: 0px 6px 12px rgba(0, 0, 0, 0.16);
                background: #fff;
                color: #B00F0C;
                font-family: 'Font Bold';
                font-size: 18px;
                cursor: pointer;
            }
        }
    }
}
.account-btn{
    width: 100%;
    max-width: 300px;
    button{
        all: unset;
        width: 100%;
        height: 60px;
        border-radius: 10px;
        border: none;
        background-color: var(--main-color);
        color: #fff;
        font-family: 'Font Bold';
        font-size: 18px;
        cursor: pointer;
    }
}
</style>